import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LookupModel } from '../../../../api/models';
import { EVENT_FLOW_FIELD_LABELS } from '../../node-parameters/constants/event-flow-field-labels.const';
import { NgIf } from '@angular/common';
import { FlexModule } from '@angular/flex-layout';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSimpleSelectComponent } from '../../../../editors/mat-simple-select/mat-simple-select.component';
import { HhaNoteTemplateComponent } from '../hha-note-template/hha-note-template.component';

@Component({
    selector: 'events-flow-hha-caregiver-notes-settings',
    templateUrl: './hha-caregiver-notes-settings.component.html',
    styleUrls: ['./hha-caregiver-notes-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        FlexModule,
        MatProgressSpinner,
        FormsModule,
        ReactiveFormsModule,
        MatSimpleSelectComponent,
        HhaNoteTemplateComponent,
    ],
})
export class EventsFlowHhaCaregiverNotesSettingsComponent {
  @Input({ required: true })
  actionItemFormGroup!: FormGroup;

  @Input({ required: true })
  caregiverNotes!: LookupModel[];

  public readonly fieldLabels = EVENT_FLOW_FIELD_LABELS;

  get templateNoteFormControl(): FormControl {
    return this.actionItemFormGroup.get('noteTemplate') as FormControl;
  }
}
